module.exports = function findValue (val, collection, toMatch) {
    return collection.filter(item => {
        let regex = new RegExp(val, 'gi')
        if (typeof (item) === 'string') {
            return item.match(regex)
        } else {
            return item[toMatch].match(regex) || item[toMatch].match(regex)
        }
    })
}